import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';

import Wrapper from './Wrapper';
import Title from './Title';
import Label from './Label';

function InfoBox({ title, children }) {
  return (
    <Wrapper>
      <Title>
        <Trans id={title} />
      </Title>
      <Label>
        {children}
      </Label>
    </Wrapper>
  );
}

InfoBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

InfoBox.defaultProps = {
  children: null,
};

export default InfoBox;



// WEBPACK FOOTER //
// ./compositions/AssetSummaryWidget/InfoBox/index.js